module.exports = __webpack_public_path__ + "img/cabbage-posterized-medium-alpha.2c064077.png";